'use client';

import { Flex, Modal, ModalBody } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { useTranslation } from '@i18n/useTranslation';
import { ReactNode } from 'react';

import IncludedByDefaultSection from './IncludedByDefaultSection';
import ProductDescription from './ProductDescription';
import { useProductInformation } from './ProductInformationContext';

type Props = {
  product: Product | MainProduct;
  prosAndConsSection: ReactNode;
};

export default function ProductInformationModal({ product, prosAndConsSection }: Props) {
  const modalTranslations = useFreddyTranslations('modal');
  const { t } = useTranslation('webshop.productPage.productInformation');
  const { isModalOpen, closeModal } = useProductInformation();

  return (
    <Modal
      open={isModalOpen}
      onClose={closeModal}
      placement='bottom'
      title={t('title')}
      size='medium'
      translations={modalTranslations}
      body={
        <ModalBody>
          <Flex direction='column' gap={300}>
            {prosAndConsSection}
            {product.mainText && <ProductDescription description={product.mainText} hideLink />}
            <IncludedByDefaultSection product={product} />
          </Flex>
        </ModalBody>
      }
    />
  );
}
